(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('load', function () {
  const banner = document.querySelector('.shopify-section:has(.main-banner-sticky)');
  if (!banner) return;

  banner.classList.add('banner-loading');

  const bannerHeight = banner.offsetHeight;
  const scrollY = window.scrollY;

  setTimeout(() => {
    if (scrollY <= bannerHeight) {
      banner.classList.add('sticky-enabled');
    }
    banner.classList.remove('banner-loading');
  }, 50);

  window.addEventListener('scroll', function () {
    const currentScroll = window.scrollY;

    if (currentScroll > bannerHeight) {
      banner.classList.add('sticky-disabled');
      banner.classList.remove('sticky-enabled');
    } else {
      banner.classList.remove('sticky-disabled');
      banner.classList.add('sticky-enabled');
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart__main"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', () => {
  // Select all spans using x-html with Shopify.formatMoney
  const moneySpans = document.querySelectorAll('span[x-html*="Shopify.formatMoney"]');

  moneySpans.forEach(span => {
    // Wait a tiny bit if Alpine hasn't rendered yet
    setTimeout(() => {
      if (span.innerHTML.includes('GBP')) {
        span.innerHTML = span.innerHTML.replace('GBP', '').trim();
      }
    }, 50); // adjust timeout if needed
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-banner-with-swiper"] && !Shopify.designMode) return;
  try {
    
// Swiper for mobile
window.addEventListener('load', function () {
const swiper = new Swiper(".blog-swiper", {
  slidesPerView: 1.25,
  spaceBetween: 12,
  draggable: true,
  freeMode: true,
  mousewheel: {
    enabled: true,
    forceToAxis: true
  },
  loop: false,
  breakpoints: {
    768: {
      slidesOffsetBefore: 550,
      slidesPerView: "auto",
      spaceBetween: 0,
    },
  },
  on: {
    init: function () {
      const firstSlide = document.querySelector('.blog-swiper .swiper-slide');
      if (firstSlide) { 
        setMetaTextHeight();
        updateMobileMetaText(firstSlide);
      }
    },
    slideChange: function () {
      updateMobileMetaText(this.slides[this.activeIndex]);
    }
  }
});

function updateMobileMetaText(slide) {
  if (window.innerWidth >= 768) return;
  
  if (!slide) {
    slide = document.querySelector('.blog-swiper .swiper-slide');
  }
  if (window.innerWidth < 768 && slide) {
    const tag = slide.dataset.tag || '';
    const title = slide.dataset.title || '';
    const excerpt = slide.dataset.excerpt || '';

    const tagEl = document.getElementById('blog-meta-tag');
    const titleEl = document.getElementById('blog-meta-title');
    const excerptEl = document.getElementById('blog-meta-excerpt');

    if (tagEl) tagEl.textContent = tag;
    if (titleEl) titleEl.textContent = title;
    if (excerptEl) excerptEl.textContent = excerpt;
  }
}

function setMetaTextHeight() {
  if (window.innerWidth >= 768) return;

  const tempTag = document.getElementById('blog-meta-tag');
  const tempTitle = document.getElementById('blog-meta-title');
  const tempExcerpt = document.getElementById('blog-meta-excerpt');
  const container = tempExcerpt.closest('.window');

  let maxHeight = 0;

  document.querySelectorAll('.swiper-slide').forEach(slide => {
    const tag = slide.dataset.tag || '';
    const title = slide.dataset.title || '';
    const excerpt = slide.dataset.excerpt || '';

    tempTag.textContent = tag;
    tempTitle.textContent = title;
    tempExcerpt.textContent = excerpt;

    const height = container.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });

  const firstSlide = document.querySelector('.swiper-slide');
  if (firstSlide) updateMobileMetaText(firstSlide);

  container.style.minHeight = maxHeight + 'px';
}
});

window.addEventListener('resize', () => {
  setMetaTextHeight();
});

  if (window.innerWidth >= 768) {
    const blocks = document.querySelectorAll('.blog-image-block');
    const tag = document.getElementById('blog-meta-tag');
    const title = document.getElementById('blog-meta-title');
    const excerpt = document.getElementById('blog-meta-excerpt');

    let activeBlock = null;

    function setActiveBlock(block) {
      if (activeBlock) activeBlock.classList.remove('is-active');
      activeBlock = block;
      activeBlock.classList.add('is-active');
      tag.textContent = block.dataset.tag || '';
      title.textContent = block.dataset.title || '';
      excerpt.textContent = block.dataset.excerpt || '';
    }

    blocks.forEach(block => {
      block.addEventListener('mouseenter', () => setActiveBlock(block));
    });

    if (blocks.length > 0) setActiveBlock(blocks[1]);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-swiper"] && !Shopify.designMode) return;
  try {
    
    new Swiper('.featured-swiper', {
        slidesPerView: 1.7,
        spaceBetween: 16,
        loop: false,
        speed: 1000,
        draggable: true,
        freeMode: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
        },
        breakpoints: {
        768: {
            slidesPerView: 1.5,
            spaceBetween: 16,
        },
        992: {
            slidesPerView: 2.5,
            spaceBetween: 16,
        },
        1441: {
          slidesPerView: 2.9,
          spaceBetween: 16,
        },
        1920: {
          slidesPerView: 3.85,
          spaceBetween: 16,
        }
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("scroll", function () {
  const sticky = document.querySelector(".main-hotspot-sticky");

  if (!sticky) return;

  const scrollPosition = window.scrollY + window.innerHeight;
  const pageHeight = document.documentElement.scrollHeight;

  if (scrollPosition >= pageHeight - 5) {
    sticky.classList.add("hidden-at-bottom");
  } else {
    sticky.classList.remove("hidden-at-bottom");
  }
});
window.addEventListener("load", function () {
  const sticky = document.querySelector(".main-hotspot-sticky");
  sticky.classList.add("main-hotspot-sticky-added")

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["other-services"] && !Shopify.designMode) return;
  try {
    
new Swiper('.other-services-slider', {
    slidesPerView: 1.7,
    spaceBetween: 16,
    loop: false,
    draggable: true,
    freeMode: true,
    mousewheel: {
      enabled: true,
      forceToAxis: true
    },
    scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true,
    },
    breakpoints: {
    768: {
        slidesPerView: 2.5,
        spaceBetween: 16,
    },
    992: {
        slidesPerView: 3.5,
        spaceBetween: 16,
    },
    1441: {
      slidesPerView: 4.5,
      spaceBetween: 16,
    },
    1920: {
      slidesPerView: 5.5,
      spaceBetween: 16,
    }
    }
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product__recently-viewed-swiper"] && !Shopify.designMode) return;
  try {
    
    new Swiper('.swiper-related-recent', {
        slidesPerView: 1.7,
        spaceBetween: 16,
        loop: false,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
        },
        draggable: true,
        freeMode: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true
        },
        breakpoints: {
        768: {
            slidesPerView: 1.7,
            spaceBetween: 12,
        },
        992: {
            slidesPerView: 3.45,
            spaceBetween: 16,
        },
        1441: {   
          slidesPerView: 4.5,
          spaceBetween: 16,
        },
        1920: {   
          slidesPerView: 5.5,
          spaceBetween: 16,
        }
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-media-cards"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('load', function () {
  new Swiper('.social-cards-slider', {
    slidesPerView: 1.2,
    spaceBetween: 16,
    loop: false,
    freeMode: true,
    mousewheel: {
      enabled: true,
      forceToAxis: true
    },
    scrollbar: { el: ".swiper-scrollbar", hide: false, draggable: true },
    draggable: true,
    breakpoints: { 768: { slidesPerView: 3.75, spaceBetween: 16 } }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme__announcement"]) return;
  try {
    
  window.addEventListener('load', function () {
    // Outer Swiper (handles layout, not rotating)
    new Swiper('.announcement-swiper', {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      draggable: true,
      freeMode: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
      },
    });

    // Inner Swiper (rotates center messages only)
    new Swiper('.inner-announcement-swiper', {
      slidesPerView: 1,
      loop: true,
      draggable: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      allowTouchMove: false,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme__cart"]) return;
  try {
    
            function initUpsellSwiper() {
              const swiperEl = document.querySelector('.swiper-upsell');
              if (!swiperEl) return;

              // Destroy old instance if it exists
              if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);

              const isEmpty = swiperEl.closest('.empty-cart-slider') !== null;

              new Swiper(swiperEl, {
                slidesPerView: 1.5,
                spaceBetween: 10,
                centeredSlides: true,
                draggable: true,
                freeMode: true,
                mousewheel: {
                  enabled: true,
                  forceToAxis: true
                },
                loop: true,
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                  768: { slidesPerView: isEmpty ? 1.5 : 2.3, centeredSlides: false },
                  1024: { slidesPerView: isEmpty ? 2 : 3.5, centeredSlides: false },
                  1440: { slidesPerView: isEmpty ? 2 : 3.5, centeredSlides: false },
                }
              });
            }

            // Initialize once on page load
            window.addEventListener('load', initUpsellSwiper);

            // Observe class changes to reinitialize only when empty-cart-slider toggles
            const swiperWrapper = document.querySelector('.swiper-upsell')?.parentElement;
            if (swiperWrapper) {
              let lastEmptyState = swiperWrapper.classList.contains('empty-cart-slider');

              const classObserver = new MutationObserver(() => {
                const currentEmptyState = swiperWrapper.classList.contains('empty-cart-slider');
                if (currentEmptyState !== lastEmptyState) {
                  lastEmptyState = currentEmptyState;
                  initUpsellSwiper(); // reinitialize whenever class toggles
                }
              });

              classObserver.observe(swiperWrapper, {
                attributes: true,
                attributeFilter: ['class']
              });
            }
            
  } catch(e) { console.error(e); }
})();
})();
